import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { SwitchTeaser } from '../components/SwitchTeaser';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#FAF9F7]" data-id="element-260">
      <HeroSection data-id="element-261" />
      <FeaturesSection data-id="element-262" />
      <HowItWorksSection data-id="element-263" />
      <SwitchTeaser data-id="element-264" />
      <FAQSection data-id="element-265" />
      <CTASection data-id="element-266" />
      <Footer data-id="element-267" />
    </main>;
}